<div class="container">  
    <!-- Map Component -->
    <div class="map-container">
      <div #mapRef id="map"></div>
    </div>
  </div>